export default {
  appBrand: "LocalZen",
  facebookColor: "#4766CE",
  googleColor: "#CB2929",
  centerAiEmail: "support@localzen.com",
  supportEmail: "support@localzen.com",
  storeLocatorExampleUrl: "https://sklepy.nexterio.pl/",
  regulations: "https://localzen.com/pl/regulamin-serwisu/",
  privacyPolicy: "https://localzen.com/pl/polityka-prywatnosci-2/",
  regulationsEn: "https://localzen.com/terms-of-use-2/",
  privacyPolicyEn: "https://localzen.com/privacy-policy-2/",
  blockEmailDomains: ["@appchance.com", "@example.com", "@localzen.com"],
  blockedEmailAddresses: ["admin-readonly@center.ai"],
  faq: {
    pl: "https://help.localzen.com/",
    en: "https://help.localzen.com/en/"
  },
  fullPeriod: "full",
  absoluteStartDate: "2005-01-01",
  defaultTimezone: "Europe/Warsaw",
  freeToolUrl: "https://www.localzen.com/free-tool",
  bookDemoUrl: "https://localzen.com/book-a-demo/",
  signUpUrl:
    "https://app.localzen.com/session/sign-up?access=approved&is_free_trial=true&plan=standard&locations=20&payment_cycle=monthly&price_list=LxTzxLRu8hGk&lang=en&utm_source=website&utm_medium=topbar&utm_campaign=topbar_cta&_gl=1*1yzn3uv*_gcl_aw*R0NMLjE3NDIyMTUyNjAuRUFJYUlRb2JDaE1JaDgtLTY1Q1JqQU1WN3dtaUF4MEpXREF2RUFFWUFTQUFFZ0pKbnZEX0J3RQ..*_gcl_au*MjIzNzkxNzY5LjE3MzYzNDIzMzM.*_ga*MTQwNDc4MjE4LjE3MTkyMzUzNjc.*_ga_98EZ0KNBW3*MTc0Mjk5NDczNS43MzQuMS4xNzQyOTk1NDI5LjU5LjAuMA.."
};
